import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Fade + slide up on scroll into view
export function Reveal({ children, delay = 0, y = 40, className = "", as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
}

// Masked line reveal — text rises from below an overflow-hidden wrapper
export function MaskLine({ children, delay = 0, className = "", play = true }) {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={play ? { y: "0%" } : {}}
        transition={{ duration: 1.05, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export { EASE };
